// BHP-1053: pick the active customer uuid for the app-wide customer context.
// Null means "no customer".
//
// BHP-1259: the stored choice is kept until the backend says the caller cannot
// reach that customer. It used to have to be one of the account's own
// customers, but an admin may select any customer, and an admin's account is
// linked to none of them; the switch was undone straight away.

/**
 * Resolve which customer should be active, given the account's own customer
 * uuids, the (persisted) previously chosen uuid, and whether the backend
 * answered "not found" for that chosen customer.
 */
export function resolveActiveCustomerUuid(
  customerUuids: string[],
  storedUuid: string | null,
  storedIsUnreachable = false
): string | null {
  if (customerUuids.length === 0) {
    return null;
  }
  if (storedUuid !== null && !storedIsUnreachable) {
    return storedUuid;
  }
  return customerUuids[0] ?? null;
}
